import { CoreInitiativesTasksByIdName } from './name';
import { deleteInitiativeTask } from '@api';
import { updateInitiativeReferences } from '../../_idMap/actions';
import { AMPLITUDE_EVENT, createLogSaga } from '@sonar-software/sonar-analytics';
import { createDeleteAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreInitiativesTasksByIdDeleteAsyncSlice = createDeleteAsyncSlice({
	additionalRequestSteps: [
		{
			actionHandler: createLogSaga(AMPLITUDE_EVENT.INITIATIVE_TASK_DELETED, (action) => action.data),
			type: SagaYieldType.Every
		}
	],
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request) =>
				updateInitiativeReferences([
					{
						initiativeId: request.initiativeId,
						tasks: {
							toRemoveById: request.taskId
						}
					}
				])
		]
	},
	name: CoreInitiativesTasksByIdName,
	receive: false,
	request: true,
	requestHandler: deleteInitiativeTask
});
